import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

// Card padrão do juiz
export const JudgeCard = styled.div`
  margin-bottom: 8px;
  padding: 8px;
  padding-left: 0;
  border-radius: 8px;
  background: #f5f7fa;
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

// Card do juiz com maior nota
export const JudgeCardMax = styled(JudgeCard)`
  background: #ffebee !important;
`;

// Card do juiz com menor nota
export const JudgeCardMin = styled(JudgeCard)`
  background: #ffebee !important;
`;

export const ResultsPaper = styled(Paper)`
  padding: 16px;
  margin-bottom: 16px;
  background: #fafbfc !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

export const ParentWinnerBox = styled(Box)`
  margin-bottom: 16px;
  padding: 8px;
  background: #e3f2fd !important;
  border-radius: 8px;
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

export const PlantBox = styled(Box)`
  margin-bottom: 8px;
  padding-left: 0;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 0;
`;

export const Medal = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  margin-right: 4px;
  font-size: 1.2em;
  vertical-align: middle;
  user-select: none;
`;
